import { BlockItem } from '@/models/Blocks/Itens/block-item';
import { BlockItemType } from '@/models/Blocks/Itens/Types/block-item-type';
import { BlockItemAction, BlockItemContent } from '@/models/Blocks/Itens/Types/block-content-types';

export interface CouponStruct{
    text:string,
    label?:string,
    color?:string,
    background?:string,
    copied?:string
}

interface CampaignStruct{
    content?:string|object,
    moreInfo?:string,
    close?:string
}

export class BlockPromo extends BlockItem {
    protected _label?: BlockItemContent;
    protected _title: BlockItemContent;
    protected _subtitle?: BlockItemContent;
    protected _coupon: string|CouponStruct;
    protected _campaign?:CampaignStruct;
    protected _action?: BlockItemAction;
    protected _cssClass?: string;
    
    public constructor(title: BlockItemContent, coupon: string|CouponStruct, subtitle: BlockItemContent|undefined = undefined, label: BlockItemContent|undefined = undefined) {
        super(BlockItemType.promo);
        this._title = title;
        this._label = label;
        this._subtitle = subtitle;
        this._coupon = coupon;
    }

    public get title():BlockItemContent{
        return this._title;
    }

    public get label():BlockItemContent|undefined{
        return this._label;
    }

    public get subtitle():BlockItemContent|undefined{
        return this._subtitle ?? undefined;
    }

    public get coupon():string|CouponStruct{
        return this._coupon;
    }

    public get campaign():CampaignStruct|undefined{
        return this._campaign;
    }

    public set campaign(value: CampaignStruct|undefined){
        this._campaign = value;
    }

    public get action(): BlockItemAction|undefined{
        return this._action;
    }

    public set action(value: BlockItemAction|undefined) {
        this._action = value;
    }

    public get cssClass(): string|undefined {
        return this._cssClass;
    }

    public set cssClass(value: string|undefined) {
        this._cssClass = value;
    }
}